import { useFormikContext, getIn } from 'formik'
import React, { FC, useCallback, RefObject, useEffect, useRef, ChangeEventHandler } from 'react'
import { Input, InputNumber, InputProps, InputNumberProps, InputRef } from 'antd'

type FormikInputType = InputNumberProps & InputProps

export interface IFormikInput extends FormikInputType {
	name: string
}

const FormikInput: FC<IFormikInput> = inputProps => {
	const { values, setFieldValue, handleBlur } = useFormikContext<Record<string, string>>()
	const value = getIn(values, inputProps.name)
	const inputRef = useRef() as RefObject<InputRef>
	const inputNumberRef = useRef() as RefObject<HTMLInputElement>

	const isNumberType = inputProps.type === 'number'

	useEffect(() => {
		if (value !== undefined && value !== null) {
			if (isNumberType) {
				if (inputNumberRef.current && !inputNumberRef.current.value) {
					inputNumberRef.current.value = value
				}
			} else if (inputRef.current?.input) {
				inputRef.current.input.value = value
			}
		}
	}, [value, isNumberType])

	const onChange = (valueToSet: number | string) => {
		setFieldValue(inputProps.name, valueToSet)
	}

	const persistedOnChange = useCallback(
		(e: ChangeEventHandler<HTMLInputElement> | any) => {
			const valueToSet = isNumberType ? e : e.target.value
			onChange(valueToSet)
			if (inputRef.current?.input) {
				inputRef.current.input.value = valueToSet
			}
		},
		[isNumberType, onChange]
	)

	if (isNumberType) {
		return (
			<InputNumber
				ref={inputNumberRef}
				value={value}
				onChange={persistedOnChange}
				onBlur={handleBlur}
				onWheel={e => (e.target as any).blur()}
				{...inputProps}
			/>
		)
	}

	if (inputProps.type === 'password') {
		return (
			<Input.Password ref={inputRef} value={value} onChange={persistedOnChange} onBlur={handleBlur} {...inputProps} />
		)
	}

	return <Input ref={inputRef} value={value} onChange={persistedOnChange} onBlur={handleBlur} {...inputProps} />
}

export default FormikInput
